<template>
  <el-dialog
    v-model="dialogVisible"
    width="600px"
    title=""
    :show-close="false"
    :close-on-click-modal="false"
    modal-class="missing-email-dialog"
  >
    <template #header>
      <div class="dialog-header">
        <div class="header-content">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="header-icon">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#D10000"/>
          </svg>
          <span class="header-title">Email & SMTP Setting Required</span>
        </div>
        <button class="close-button" @click="closeDialog">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="#D10000"/>
          </svg>
        </button>
      </div>
    </template>

    <div class="dialog-content">
      <p class="description-text">
        You need to set up your clinic branding communication path to use this feature. To change this setting, visit <span class="bold-text">Email & SMTP Settings</span> in <span class="bold-text">Practice Branding</span> in My Practice.
      </p>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <div class="footer-divider"></div>
        <div class="footer-actions">
          <button class="action-button" @click="closeDialog">
            Go set up now.
          </button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'MissingEmailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:visible'],
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style>
.missing-email-dialog .el-overlay-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.missing-email-dialog .el-dialog {
  border-radius: 10px;
  margin: 0 auto;
  --el-dialog-padding-primary: 0px !important;
}

.missing-email-dialog .el-dialog__header {
  padding: 0;
  margin: 0;
}

.missing-email-dialog .el-dialog__body {
  padding: 0;
}

.missing-email-dialog .el-dialog__footer {
  padding: 0;
}
</style>

<style scoped>
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #faeaea;
  border-radius: 10px 10px 0 0;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 4px;
}

.header-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.header-title {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: normal;
  color: #D10000;
}

.close-button {
  background: transparent;
  border: none;
  cursor: pointer;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.dialog-content {
  padding: 24px 32px;
  background: #f9fbfd;
}

.description-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.4px;
  color: #333;
  margin: 0;
}

.bold-text {
  font-weight: 700;
}

.dialog-footer {
  padding: 0 24px 24px 24px;
  background: #f9fbfd;
  border-radius: 0 0 10px 10px;
}

.footer-divider {
  border-top: 1px dashed #C4C4C4;
  padding-top: 24px;
}

.footer-actions {
  display: flex;
  justify-content: center;
}

.action-button {
  background: #004879;
  border: none;
  border-radius: 4px;
  padding: 8px 32px;
  height: 40px;
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: white;
  cursor: pointer;
  box-shadow: 0px 1px 3px 0px rgba(74, 74, 74, 0.25);
  transition: opacity 0.2s;
}

.action-button:hover {
  opacity: 0.8;
}
</style>
